<template>
  <div class="w-100 d-flex justify-content-center">
    <form class="pl-5 pr-5 main-view" @submit.prevent="sendAction()" id="mainForm">
      <div class="row mt-0">
        <div class="col-3 text-start">
          <span class="fw-bold">責任者名</span>
        </div>
        <div class="col-7">
          <div class="d-flex flex-row gap-3">
            <div>
              <div class="mb-1 text-start">
                <label for="inputName" class="form-label fw-bold m-0">氏名</label>
                <input
                  type="text"
                  id="inputName"
                  v-model="name01"
                  class="border border-1 border-gray rounded mt-1 acry-input form-control"
                  placeholder="姓"
                  required
                />
              </div>
            </div>
            <div>
              <div class="mb-1 text-start">
                <label for="inputName2" class="form-label m-0" style="visibility: hidden"
                  >名</label
                >
                <input
                  type="text"
                  id="inputName2"
                  v-model="name02"
                  class="border border-1 border-gray rounded mt-1 acry-input form-control"
                  placeholder="名"
                  required
                />
              </div>
            </div>
          </div>
          <div class="d-flex flex-row gap-3">
            <div>
              <div class="mb-1 mt-1 text-start">
                <label for="inputNameKana" class="form-label fw-bold m-0">カナ</label>
                <input
                  type="text"
                  id="inputNameKana"
                  v-model="kana01"
                  class="border border-1 border-gray rounded mt-1 acry-input form-control"
                  placeholder="カナ"
                  required
                />
              </div>
            </div>
            <div>
              <div class="mb-1 mt-1 text-start">
                <label
                  for="inputName2Kana"
                  class="form-label m-0"
                  style="visibility: hidden"
                  >メイ</label
                >
                <input
                  type="text"
                  id="inputName2Kana"
                  v-model="kana02"
                  class="border border-1 border-gray rounded mt-1 acry-input form-control"
                  placeholder="メイ"
                  required
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="w-100">
          <hr/>
        </div>
      </div>

      <!-- 法人用フォーム -->
      <div v-if="!isIndividual">
        <div class="row mt-1 mb-2">
          <div class="col-3 text-start">
            <span class="fw-bold">会社名</span>
          </div>
          <div class="col-7">
            <div class="text-start">
              <input
                type="text"
                id="address"
                class="border border-1 border-gray rounded mt-1 acry-input form-control"
                v-model="company_name"
                style="width: 616px"
                placeholder="〇〇株式会社"
                required
              />
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="w-100">
            <hr/>
          </div>
        </div>
        <div class="row mt-1 mb-2">
          <div class="col-3 text-start">
            <span class="fw-bold">部署名</span>
          </div>
          <div class="col-7">
            <div class="text-start">
              <input
                type="text"
                id="address"
                class="border border-1 border-gray rounded mt-1 acry-input form-control"
                v-model="department_name"
                style="width: 616px"
                placeholder="〇〇部"
                required
              />
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="w-100">
            <hr/>
          </div>
        </div>

      </div>

      <!-- 個人用フォーム -->
      <div v-if="isIndividual">
        <div class="row mt-1 mb-2">
          <div class="col-3 text-start">
            <span class="fw-bold">屋号</span>
          </div>
          <div class="col-7">
            <div class="text-start">
              <input
                type="text"
                id="address"
                class="border border-1 border-gray rounded mt-1 acry-input form-control"
                v-model="company_name"
                style="width: 616px"
                placeholder="〇〇株式会社"
                required
              />
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="w-100">
            <hr/>
          </div>
        </div>
      </div>

      <div class="row mt-1">
        <div class="col-3 text-start">
          <span class="fw-bold">住所</span>
        </div>
        <div class="col-7">
          <div class="text-start row">
            <span class="col-auto p-1" style="margin: auto 6px;">〒</span>
            <input
              type="text"
              id="inputCode"
              class="border border-1 border-gray rounded mt-0 acry-input"
              v-model="zip"
              maxlength="7"
              style="width: 129px"
              placeholder="0000000"
              required
            />
            <div class="col-auto" style="margin: auto 0px;">
              <button type="button" class="btn" style="background:#838FB1; color:white" v-on:click="findAddress">
                住所検索
              </button>
            </div>
          </div>

          <select
            class="text-start form-select mt-3"
            name="pref_id"
            id="inputCity"
            v-model="pref"
            style="width: 160px; height: 40px; font-size: 14px"
          >
            <option disabled value="default">都道府県を選択</option>

            <option value="1">北海道</option>
            <option value="2">青森県</option>
            <option value="3">岩手県</option>
            <option value="4">宮城県</option>
            <option value="5">秋田県</option>
            <option value="6">山形県</option>
            <option value="7">福島県</option>
            <option value="8">茨城県</option>
            <option value="9">栃木県</option>
            <option value="10">群馬県</option>
            <option value="11">埼玉県</option>
            <option value="12">千葉県</option>
            <option value="13">東京都</option>
            <option value="14">神奈川県</option>
            <option value="15">新潟県</option>
            <option value="16">富山県</option>
            <option value="17">石川県</option>
            <option value="18">福井県</option>
            <option value="19">山梨県</option>
            <option value="20">長野県</option>
            <option value="21">岐阜県</option>
            <option value="22">静岡県</option>
            <option value="23">愛知県</option>
            <option value="24">三重県</option>
            <option value="25">滋賀県</option>
            <option value="26">京都府</option>
            <option value="27">大阪府</option>
            <option value="28">兵庫県</option>
            <option value="29">奈良県</option>
            <option value="30">和歌山県</option>
            <option value="31">鳥取県</option>
            <option value="32">島根県</option>
            <option value="33">岡山県</option>
            <option value="34">広島県</option>
            <option value="35">山口県</option>
            <option value="36">徳島県</option>
            <option value="37">香川県</option>
            <option value="38">愛媛県</option>
            <option value="39">高知県</option>
            <option value="40">福岡県</option>
            <option value="41">佐賀県</option>
            <option value="42">長崎県</option>
            <option value="43">熊本県</option>
            <option value="44">大分県</option>
            <option value="45">宮崎県</option>
            <option value="46">鹿児島県</option>
            <option value="47">沖縄県</option>
          </select>

          <div class="text-start  mt-3">
            <input
              type="address"
              id="address"
              class="input border border-1 border-gray rounded mt-1 acry-input"
              v-model="addr01"
              placeholder="市町村名(例：大阪市北区)"
              style="width: 616px"
              required
            />
          </div>
          <div class="text-start  mt-3">
            <input
              type="address"
              id="address"
              class="input border border-1 border-gray rounded mt-1 acry-input"
              v-model="addr02"
              placeholder="番地・ビル名(例：西梅田1丁目6-8)"
              style="width: 616px"
            />
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="w-100">
          <hr/>
        </div>
      </div>

      <div class="row mt-1 mb-2">
        <div class="col-3 text-start">
          <span class="fw-bold">電話番号</span>
        </div>

        <div class="col-auto text-start">
          <input
            type="text"
            id="phone"
            class="input border border-1 border-gray rounded mt-1 acry-input"
            v-model="tel01"
            pattern="^[0-9]+$"
            style="width:100px"
            required
          />
        </div>
        <div class="col-auto p-0 m-0">
          <p class="text-dark m-0 p-0" style="line-height: 40px">-</p>
        </div>

        <div class="col-auto">
          <input
            type="text"
            id="phone"
            class="input border border-1 border-gray rounded mt-1 acry-input"
            v-model="tel02"
            pattern="^[0-9]+$"
            style="width:100px"
            required
          />
        </div>
        <div class="col-auto p-0 m-0">
          <p class="text-dark m-0 p-0" style="line-height: 40px">-</p>
        </div>

        <div class="col-auto">
          <input
            type="text"
            id="phone"
            class="input border border-1 border-gray rounded mt-1 acry-input"
            v-model="tel03"
            pattern="^[0-9]+$"
            style="width:100px"
            required
          />
        </div>
        <div class="col-2"></div>
      </div>

      <div class="row mt-3 justify-content-center">
        <div class="w-100">
          <hr/>
        </div>
      </div>

      <div class="row justify-content-center mt-3 mb-3">
          <button class="acry-btn-primary-normal fw-bold" style="width:240px;height:56px;">変更する</button>
      </div>

      <div class="w-100" style="height:40px;"></div>
    </form>
  </div>
</template>

<script>
import { User } from "@/js/User.js";
import firebase from "firebase/app";
import "firebase/auth";
import { handleError } from "@/js/utils/ErrorHandler.js";

export default {
  name: "CenterViewShippingUser_Ap",
  components: {
  },
  props: {},
  async created() {
    const fbUserData = await User.getFBAcryProUserData().catch(() => {
      console.log("エラー");
    });

    if( fbUserData && "isIndividual" in fbUserData && fbUserData.isIndividual ){
      this.isIndividual = true;
    }

    // 登録されている住所の取得
    const userInfo = await User.getInfo().catch(() => {
      console.log("エラー");
    });
    if (userInfo != null) {
      this.name01 = userInfo.name01;
      this.name02 = userInfo.name02;
      this.kana01 = userInfo.kana01;
      this.kana02 = userInfo.kana02;
      this.tel01 = userInfo.tel01;
      this.tel02 = userInfo.tel02;
      this.tel03 = userInfo.tel03;
      this.zip = "" + userInfo.zip01 + userInfo.zip02;
      this.addr01 = userInfo.addr01;
      this.addr02 = userInfo.addr02;
      this.pref = userInfo.pref;
      this.company_name = userInfo.company_name;
      this.department_name = userInfo.department_name;
    }
  },
  data() {
    return {
      isIndividual: false,
      company_name: "",
      department_name:"",
      name01: "",
      name02: "",
      kana01: "",
      kana02: "",
      email: "",
      tel01: "",
      tel02: "",
      tel03: "",
      addr01: "",
      addr02: "",
      zip: "",
      password: "",
      isLoading: false,
      isEnd: false,
      pref: "default",
    };
  },
  methods: {
    findAddress: function () {
      let YubinBango = require("yubinbango-core2");
      new YubinBango.Core(this.zip, (addr) => {
        this.pref = addr.region_id;
        this.addr01 = addr.locality + addr.street;
        this.addr02 = "";
      });
    },
    inputCheck() {
      return true;
    },
    async sendAction() {
      // 入力チェック
      if (!this.inputCheck()) {
        this.$store.commit("showMessage", "入力内容を確認してください");
        return;
      }
      // 登録
      this.$store.commit("showLoading");
      let store = this.$store;
      var isError = false;
      this.email = firebase.auth().currentUser.email;
      await User.registInfo({
        name01: this.name01,
        name02: this.name02,
        kana01: this.kana01,
        kana02: this.kana02,
        tel01: this.tel01,
        tel02: this.tel02,
        tel03: this.tel03,
        addr01: this.addr01,
        addr02: this.addr02,
        zip01: this.zip.substring(0, 3),
        zip02: this.zip.substring(3, 7),
        company_name: this.company_name,
        department_name: this.department_name,
        pref: this.pref,
        email: this.email,
      }).catch((error) => {
        handleError(store, "078", error, { hideLoading: true });
        isError = true;
      });
      if (!isError) {
        User.authPartnerCode("XXXXXXXX")
          .then(function () {
            store.commit("showMessage", "保存しました");
            store.commit("hideLoading");
            store.commit("showMessage", "保存しました");
          })
          .catch(function (error) {
            handleError(store, "079", error, { hideLoading: true });
          });
      }
    },
  },
};
</script>

<style scoped>
.main-view {
  width: 888px;
  height: 724px;
}
.login {
  width: 400px;
  height: 300px;
}
.acry-input {
  width: 300px;
  height: 40px;
  padding-left: 10px;
}
.mustlbl {
  color: white;
  background: #bc6665;
  border-radius: 3px;
  padding: 5px 12px 5px 12px;
}
</style>
